__turbopack_context__.v({
  "sliderFullWidth": "slider-module-scss-module__USvQBq__sliderFullWidth",
});
